//省份
var cProvinceDatas = new Array();
cProvinceDatas.push(
  "安徽省|31.86646*117.29172@31.868453*117.286192|5|3407872|A"
);
cProvinceDatas.push(
  "福建省|26.07912*119.30491@26.082222*119.300104|5|3473408|F"
);
cProvinceDatas.push(
  "广东省|23.13399*113.26006@23.136667*113.254734|5|4456448|G"
);
cProvinceDatas.push(
  "广西省|22.82527*108.33199@22.828018*108.327985|5|4521984|G"
);
cProvinceDatas.push(
  "甘肃省|36.07967*103.77926@36.079901*103.776756|5|6422528|G"
);
cProvinceDatas.push(
  "贵州省|26.58719*106.7139@26.590719*106.710134|5|5373952|G"
);
cProvinceDatas.push(
  "河北省|38.04502*114.52002@38.044399*114.514042|5|1245184|H"
);
cProvinceDatas.push(
  "河南省|34.76714*113.67769@34.768225*113.671573|5|4259840|H"
);
cProvinceDatas.push(
  "湖北省|30.58965*114.28742@30.592094*114.282001|5|4325376|H"
);
cProvinceDatas.push(
  "湖南省|28.19602*112.99369@28.199407*112.988092|5|4390912|H"
);
cProvinceDatas.push(
  "海南省|20.04501*110.35734@20.04703*110.352922|5|4587520|H"
);
cProvinceDatas.push(
  "黑龙江省|45.73957*126.66254@45.73759*126.656537|5|2293760|H"
);
cProvinceDatas.push(
  "吉林省|43.8929*125.32512@43.890499*125.318615|5|2228224|J"
);
cProvinceDatas.push(
  "江苏省|32.05892*118.79349@32.060983*118.788292|5|3276800|J"
);
cProvinceDatas.push(
  "江西省|28.66246*115.91655@28.665835*115.911714|5|3538944|J"
);
cProvinceDatas.push("辽宁省|41.81073*123.38035@41.8083*123.374235|5|2162688|L");
cProvinceDatas.push("宁夏|38.47426*106.28956@38.473786*106.285127|5|6553600|N");
cProvinceDatas.push(
  "内蒙古|40.81635*111.68104@40.815016*111.674252|5|1376256|N"
);
cProvinceDatas.push(
  "青海省|36.62695*101.80335@36.627056*101.801462|5|6488064|Q"
);
cProvinceDatas.push("其它|22.31881*114.18144@22.321572*114.176492|5||Q");
cProvinceDatas.push(
  "山东省|36.65319*116.97009@36.653038*116.964396|5|3604480|S"
);
cProvinceDatas.push(
  "四川省|30.66431*104.07043@30.666725*104.067918|5|5308416|S"
);
cProvinceDatas.push(
  "陕西省|34.30017*108.9976@34.301612*108.992755|5|6356992|S"
);
cProvinceDatas.push(
  "山西省|37.87319*112.59966@37.872718*112.593419|5|1310720|S"
);
cProvinceDatas.push("西藏|29.67571*91.12836@29.678421*91.126809|5|5505024|X");
cProvinceDatas.push("新疆|43.80553*87.61988@43.804312*87.617031|5|6619136|X");
cProvinceDatas.push(
  "云南省|25.03736*102.71037@25.040337*102.708936|5|5439488|Y"
);
cProvinceDatas.push(
  "浙江省|30.25748*120.1673@30.259824*120.162629|5|3342336|Z"
);
cProvinceDatas.push(
  "上海市|31.23394*121.47308@31.229995*121.467165|5|3211264|S"
);
cProvinceDatas.push(
  "北京市|39.92343*116.3974@39.925712*116.384291|5|1114112|B"
);
cProvinceDatas.push(
  "天津市|39.13006*117.22137@39.125847*117.213713|5|1179648|T"
);
cProvinceDatas.push("重庆市|29.5633*106.5509@29.566733*106.544428|5|5242880|C");
cProvinceDatas.push("香港|22.28783*114.16855@22.289297*114.166327|5|8454144|X");
cProvinceDatas.push("澳门|22.18868*113.54507@22.187147*113.536515|5|8519680|A");
cProvinceDatas.push(
  "台湾省|23.90593*120.99243@24.02677*120.997036|5|8519680|T"
);

//城市
var cCityDatas = new Array();

cCityDatas["上海市"] = new Array();
cCityDatas["上海市"].push(
  "上海市|31.23394*121.47308@31.229995*121.467165|5|3211264|S"
);
cCityDatas["北京市"] = new Array();
cCityDatas["北京市"].push(
  "北京市|39.92343*116.3974@39.925712*116.384291|5|1114112|B"
);
cCityDatas["天津市"] = new Array();
cCityDatas["天津市"].push(
  "天津市|39.13006*117.22137@39.125847*117.213713|5|1179648|T"
);
cCityDatas["重庆市"] = new Array();
cCityDatas["重庆市"].push(
  "重庆市|29.5633*106.5509@29.566733*106.544428|5|5242880|C"
);
cCityDatas["香港"] = new Array();
cCityDatas["香港"].push(
  "香港|22.28783*114.16855@22.289297*114.166327|5|8454144|X"
);
cCityDatas["澳门"] = new Array();
cCityDatas["澳门"].push(
  "澳门|22.18868*113.54507@22.187147*113.536515|5|8519680|A"
);

cCityDatas["河北省"] = new Array();
cCityDatas["河北省"].push(
  "石家庄市|38.04502*114.52002@38.044399*114.514042|7|1245440|S"
);
cCityDatas["河北省"].push(
  "邯郸市|36.61044*114.49076@36.610217*114.484824|8|1246208|H"
);
cCityDatas["河北省"].push(
  "邢台市|37.07036*114.49854@37.069846*114.492584|8|1246464|X"
);
cCityDatas["河北省"].push(
  "保定市|38.87262*115.49815@38.871797*115.491932|8|1246720|B"
);
cCityDatas["河北省"].push(
  "张家口市|40.81864*114.88464@40.817313*114.878518|8|1246976|Z"
);
cCityDatas["河北省"].push(
  "承德市|40.96843*117.93583@40.9669*117.929567|8|1247232|C"
);
cCityDatas["河北省"].push(
  "唐山市|39.63617*118.20599@39.634894*118.199766|8|1245696|T"
);
cCityDatas["河北省"].push(
  "秦皇岛市|39.94656*119.5808@39.945439*119.574997|8|1245952|Q"
);
cCityDatas["河北省"].push(
  "沧州市|38.30781*116.84271@38.307248*116.836916|8|1247488|C"
);
cCityDatas["河北省"].push(
  "廊坊市|39.51937*116.7008@39.518255*116.694856|8|1249280|L"
);
cCityDatas["河北省"].push(
  "衡水市|37.7313*115.6864@37.730637*115.680491|8|1249536|H"
);

cCityDatas["山西省"] = new Array();
cCityDatas["山西省"].push(
  "太原市|37.87319*112.59966@37.872718*112.593419|7|1310976|T"
);
cCityDatas["山西省"].push(
  "大同市|40.09267*113.28761@40.091496*113.280628|8|1311232|D"
);
cCityDatas["山西省"].push(
  "阳泉市|37.86083*113.57747@37.860319*113.571053|8|1311488|Y"
);
cCityDatas["山西省"].push(
  "长治市|36.20428*113.11301@36.204106*113.106341|8|1311744|C"
);
cCityDatas["山西省"].push(
  "晋城市|35.50014*112.83657@35.500509*112.83042|8|1312000|J"
);
cCityDatas["山西省"].push(
  "朔州市|39.32968*112.42729@39.328506*112.420427|8|1312256|S"
);
cCityDatas["山西省"].push(
  "晋中市|37.68649*112.74621@37.685812*112.739725|8|1312512|J"
);
cCityDatas["山西省"].push(
  "忻州市|38.40344*112.73961@38.402861*112.733045|8|1313024|X"
);
cCityDatas["山西省"].push(
  "吕梁市|37.52305*111.1359@37.522252*111.129525|8|1315072|L"
);
cCityDatas["山西省"].push(
  "临汾市|36.08199*111.52049@36.082101*111.514258|8|1314816|L"
);
cCityDatas["山西省"].push(
  "运城市|35.02422*110.99076@35.025026*110.985049|8|1312768|Y"
);

cCityDatas["内蒙古"] = new Array();
cCityDatas["内蒙古"].push(
  "呼和浩特市|40.81635*111.68104@40.815016*111.674252|7|1376512|H"
);
cCityDatas["内蒙古"].push(
  "包头市|40.65486*109.83404@40.653692*109.828306|9|1376768|B"
);
cCityDatas["内蒙古"].push(
  "乌海市|39.68081*106.81665@39.679893*106.811911|9|1377024|W"
);
cCityDatas["内蒙古"].push(
  "赤峰市|42.26299*118.95102@42.261019*118.944791|9|1377280|C"
);
cCityDatas["内蒙古"].push(
  "乌兰察布市|41.03318*113.10717@41.031357*113.099876|9|1378560|W"
);
cCityDatas["内蒙古"].push(
  "锡林郭勒盟|43.93713*116.08243@43.934901*116.075543|9|1385728|X"
);
cCityDatas["内蒙古"].push(
  "呼伦贝尔市|49.20731*119.76371@49.205366*119.756353|9|1378048|H"
);
cCityDatas["内蒙古"].push(
  "鄂尔多斯市|39.82015*109.99629@39.819109*109.990566|9|1377792|E"
);
cCityDatas["内蒙古"].push(
  "巴彦淖尔盟|40.75587*107.41316@40.754409*107.407551|9|1378304|B"
);
cCityDatas["内蒙古"].push(
  "兴安盟|46.0716*122.06656@46.069577*122.060377|9|1384960|X"
);
cCityDatas["内蒙古"].push(
  "阿拉善盟|38.84842*105.64492@38.847999*105.640878|9|1386752|A"
);
cCityDatas["内蒙古"].push(
  "通辽市|43.60979*122.26579@43.607411*122.260244|9|1377536|T"
);

cCityDatas["辽宁省"] = new Array();
cCityDatas["辽宁省"].push(
  "沈阳市|41.81073*123.38035@41.8083*123.374235|8|2162944|S"
);
cCityDatas["辽宁省"].push(
  "大连市|38.92425*121.62329@38.923464*121.618344|8|2163200|D"
);
cCityDatas["辽宁省"].push(
  "鞍山市|41.10736*122.99014@41.105472*122.984687|8|2163456|A"
);
cCityDatas["辽宁省"].push(
  "抚顺市|41.87913*123.90556@41.877041*123.899858|8|2163712|F"
);
cCityDatas["辽宁省"].push(
  "本溪市|41.29104*123.76104@41.288949*123.755148|8|2163968|B"
);
cCityDatas["辽宁省"].push(
  "丹东市|40.12404*124.37858@40.122459*124.372761|8|2164224|D"
);
cCityDatas["辽宁省"].push(
  "锦州市|41.12001*121.12818@41.117937*121.122528|8|2164480|J"
);
cCityDatas["辽宁省"].push(
  "营口市|40.67802*122.23395@40.676443*122.228769|8|2164736|Y"
);
cCityDatas["辽宁省"].push(
  "阜新市|42.01213*121.6496@42.010066*121.644247|8|2164992|F"
);
cCityDatas["辽宁省"].push(
  "辽阳市|41.26683*123.16629@41.264653*123.160461|8|2166784|L"
);
cCityDatas["辽宁省"].push(
  "铁岭市|42.29571*123.84595@42.29359*123.840087|8|2167296|T"
);
cCityDatas["辽宁省"].push(
  "朝阳市|41.57195*120.44236@41.569639*120.436639|8|2167552|C"
);
cCityDatas["辽宁省"].push(
  "盘锦市|41.19227*122.04954@41.190169*122.04409|8|2167040|P"
);
cCityDatas["辽宁省"].push(
  "葫芦岛市|40.75609*120.85199@40.754626*120.846833|10|2167808|H"
);

cCityDatas["吉林省"] = new Array();
cCityDatas["吉林省"].push(
  "长春市|43.8929*125.32512@43.890499*125.318615|8|2228480|C"
);
cCityDatas["吉林省"].push(
  "吉林市|43.85569*126.5646@43.853462*126.558932|8|2228736|J"
);
cCityDatas["吉林省"].push(
  "四平市|43.16796*124.35953@43.165379*124.353318|8|2228992|S"
);
cCityDatas["吉林省"].push(
  "辽源市|42.90147*125.14163@42.898933*125.135216|8|2229248|L"
);
cCityDatas["吉林省"].push(
  "通化市|41.72584*125.93401@41.723692*125.928367|8|2229504|T"
);
cCityDatas["吉林省"].push(
  "白城市|45.62103*122.84259@45.619117*122.836715|8|2230272|B"
);
cCityDatas["吉林省"].push(
  "延边|43.18806*129.42181@43.185302*129.414597|8|2237440|Y"
);
cCityDatas["吉林省"].push(
  "白山市|41.93672*126.42042@41.934207*126.414555|8|2229760|B"
);
cCityDatas["吉林省"].push(
  "松原市|45.12118*124.81485@45.119184*124.80853|8|2230016|S"
);

cCityDatas["江苏省"] = new Array();
cCityDatas["江苏省"].push(
  "南京市|32.05892*118.79349@32.060983*118.788292|7|3277056|N"
);
cCityDatas["江苏省"].push(
  "徐州市|34.2644*117.18011@34.2656*117.174318|8|3277568|X"
);
cCityDatas["江苏省"].push(
  "连云港市|34.601*119.17806@34.601953*119.172433|8|3278592|L"
);
cCityDatas["江苏省"].push(
  "淮安市|33.59535*119.01645@33.596762*119.011009|8|3278848|H"
);
cCityDatas["江苏省"].push(
  "盐城市|33.38395*120.13363@33.385311*120.128587|8|3279104|Y"
);
cCityDatas["江苏省"].push(
  "扬州市|32.39429*119.44767@32.396202*119.442238|8|3280896|Y"
);
cCityDatas["江苏省"].push(
  "南通市|32.02597*120.85978@32.028112*120.855517|8|3278336|N"
);
cCityDatas["江苏省"].push(
  "镇江市|32.20389*119.45006@32.205799*119.444653|8|3281152|Z"
);
cCityDatas["江苏省"].push(
  "常州市|31.79847*119.97573@31.800517*119.970988|8|3277824|C"
);
cCityDatas["江苏省"].push(
  "无锡市|31.58131*120.31118@31.583199*120.306571|8|3277312|W"
);
cCityDatas["江苏省"].push(
  "苏州市|31.31316*120.63331@31.315321*120.629123|8|3278080|S"
);
cCityDatas["江苏省"].push(
  "泰州市|32.49174*119.91498@32.493965*119.910239|8|3281408|T"
);
cCityDatas["江苏省"].push(
  "宿迁市|33.96095*118.29463@33.962281*118.28911|8|3281664|S"
);

cCityDatas["浙江省"] = new Array();
cCityDatas["浙江省"].push(
  "杭州市|30.25748*120.1673@30.259824*120.162629|8|3342592|H"
);
cCityDatas["浙江省"].push(
  "宁波市|29.8801*121.56081@29.882695*121.556667|8|3342848|N"
);
cCityDatas["浙江省"].push(
  "温州市|28.02152*120.65878@28.024889*120.654805|8|3343104|W"
);
cCityDatas["浙江省"].push(
  "嘉兴市|30.75119*120.74956@30.753486*120.74524|8|3343360|J"
);
cCityDatas["浙江省"].push(
  "绍兴市|30.00989*120.58919@30.012529*120.585115|8|3343872|S"
);
cCityDatas["浙江省"].push(
  "金华市|29.11044*119.67453@29.113348*119.669791|8|3344128|J"
);
cCityDatas["浙江省"].push(
  "衢州市|28.93888*118.86995@28.941996*118.865166|8|3344384|Q"
);
cCityDatas["浙江省"].push(
  "舟山市|30.01514*122.10103@30.017392*122.096664|8|3344640|Z"
);
cCityDatas["浙江省"].push(
  "台州市|28.68495*121.43664@28.687894*121.432224|8|3346432|T"
);
cCityDatas["浙江省"].push(
  "丽水市|28.4558*119.91244@28.459217*119.908033|9|3346688|L"
);
cCityDatas["浙江省"].push(
  "湖州市|30.86689*120.09324@30.868947*120.088371|10|3343616|H"
);

cCityDatas["安徽省"] = new Array();
cCityDatas["安徽省"].push(
  "合肥市|31.86646*117.29172@31.868453*117.286192|7|3408128|A"
);
cCityDatas["安徽省"].push(
  "淮南市|32.66046*117.04224@32.66239*117.036665|8|3408896|H"
);
cCityDatas["安徽省"].push(
  "芜湖市|31.34967*118.3738@31.351525*118.368401|8|3408384|W"
);
cCityDatas["安徽省"].push(
  "安庆市|30.52774*117.05042@30.530061*117.045014|8|3409920|A"
);
cCityDatas["安徽省"].push(
  "黄山市|29.72064*118.32944@29.723063*118.324258|8|3411968|H"
);
cCityDatas["安徽省"].push(
  "宿州市|33.6422*116.97726@33.643746*116.971848|8|3412736|S"
);
cCityDatas["安徽省"].push(
  "巢湖市|31.60151*117.86134@31.603635*117.856051|8|3412992|C"
);
cCityDatas["安徽省"].push(
  "池州市|30.65941*117.48284@30.661731*117.477326|8|3413760|C"
);
cCityDatas["安徽省"].push(
  "六安市|31.75806*116.50035@31.760056*116.495183|8|3413248|L"
);
cCityDatas["安徽省"].push(
  "阜阳市|32.91043*115.81086@32.912398*115.805464|8|3412480|F"
);
cCityDatas["安徽省"].push(
  "马鞍山市|31.68128*118.4995@31.683236*118.494273|8|3409152|M"
);
cCityDatas["安徽省"].push(
  "铜陵市|30.92991*117.80755@30.932194*117.802187|8|3409664|T"
);
cCityDatas["安徽省"].push(
  "滁州市|32.30298*118.31417@32.305003*118.308783|8|3412224|C"
);
cCityDatas["安徽省"].push(
  "宣城市|30.94691*118.75149@30.949124*118.746365|8|3414016|X"
);
cCityDatas["安徽省"].push(
  "亳州市|33.87526*115.78067@33.876692*115.775123|8|3413504|H"
);
cCityDatas["安徽省"].push(
  "淮北市|33.97454*116.78984@33.975944*116.784424|8|3409408|H"
);
cCityDatas["安徽省"].push(
  "蚌埠市|32.94222*117.38358@32.943917*117.377743|8|3408640|B"
);

cCityDatas["福建省"] = new Array();
cCityDatas["福建省"].push(
  "福州市|26.07912*119.30491@26.082222*119.300104|8|3473664|F"
);
cCityDatas["福建省"].push(
  "厦门市|24.46792*118.09924@24.470563*118.094264|8|3473920|X"
);
cCityDatas["福建省"].push(
  "三明市|26.26706*117.63373@26.270502*117.628842|8|3474432|S"
);
cCityDatas["福建省"].push(
  "莆田市|25.43473*119.00669@25.437525*119.001976|8|3474176|P"
);
cCityDatas["福建省"].push(
  "泉州市|24.91486*118.59437@24.917859*118.589923|8|3474688|Q"
);
cCityDatas["福建省"].push(
  "漳州市|24.51441*117.65339@24.517387*117.648601|8|3474944|Z"
);
cCityDatas["福建省"].push(
  "南平市|26.64459*118.17304@26.647869*118.168028|8|3475200|N"
);
cCityDatas["福建省"].push(
  "宁德市|26.66696*119.52011@26.670372*119.515419|8|3475712|N"
);
cCityDatas["福建省"].push(
  "龙岩市|25.09539*117.02706@25.098132*117.022165|8|3475456|L"
);

cCityDatas["江西省"] = new Array();
cCityDatas["江西省"].push(
  "南昌市|28.66246*115.91655@28.665835*115.911714|7|3539200|N"
);
cCityDatas["江西省"].push(
  "景德镇市|29.29635*117.20185@29.299006*117.19656|8|3539456|J"
);
cCityDatas["江西省"].push(
  "萍乡市|27.62671*113.84902@27.630102*113.843689|8|3539712|P"
);
cCityDatas["江西省"].push(
  "九江市|29.71515*115.98961@29.717739*115.984565|8|3539968|J"
);
cCityDatas["江西省"].push(
  "鹰潭市|28.24294*117.02708@28.246177*117.021948|8|3540480|Y"
);
cCityDatas["江西省"].push(
  "上饶市|28.44695*117.96646@28.450319*117.961446|8|3543296|S"
);
cCityDatas["江西省"].push(
  "宜春市|27.7996*114.3903@27.802702*114.384984|8|3541248|Y"
);
cCityDatas["江西省"].push(
  "抚州市|27.99251*116.35463@27.995666*116.349636|8|3543040|F"
);
cCityDatas["江西省"].push(
  "吉安市|27.11408*114.98511@27.117469*114.980169|8|3540992|J"
);
cCityDatas["江西省"].push(
  "赣州市|25.85251*114.93688@25.855711*114.932155|8|3540736|G"
);
cCityDatas["江西省"].push(
  "新余市|27.82167*114.91368@27.825133*114.908838|8|3540224|X"
);

cCityDatas["山东省"] = new Array();
cCityDatas["山东省"].push(
  "济南市|36.65319*116.97009@36.653038*116.964396|7|3604736|J"
);
cCityDatas["山东省"].push(
  "青岛市|36.10582*120.35483@36.105578*120.349725|8|3604992|Q"
);
cCityDatas["山东省"].push(
  "淄博市|36.80982*118.05825@36.809304*118.052175|8|3605248|Z"
);
cCityDatas["山东省"].push(
  "枣庄市|34.85406*117.56665@34.855044*117.560988|8|3605504|Z"
);
cCityDatas["山东省"].push(
  "东营市|37.43247*118.66868@37.431814*118.663042|8|3605760|D"
);
cCityDatas["山东省"].push(
  "潍坊市|36.71303*119.11343@36.712514*119.107464|8|3606272|W"
);
cCityDatas["山东省"].push(
  "烟台市|37.54736*121.38051@37.546341*121.375255|8|3606016|Y"
);
cCityDatas["山东省"].push(
  "威海市|37.50621*122.12184@37.505177*122.116778|8|3608576|W"
);
cCityDatas["山东省"].push(
  "济宁市|35.41508*116.58144@35.415521*116.576141|8|3606528|J"
);
cCityDatas["山东省"].push(
  "泰安市|36.18812*117.11217@36.187872*117.106092|8|3606784|T"
);
cCityDatas["山东省"].push(
  "日照市|35.41602*119.5218@35.416278*119.516331|8|3608832|R"
);
cCityDatas["山东省"].push(
  "莱芜市|36.21379*117.6694@36.213818*117.663547|8|3609088|L"
);
cCityDatas["山东省"].push(
  "德州市|37.45018*116.29707@37.449427*116.291302|8|3609600|D"
);
cCityDatas["山东省"].push(
  "滨州市|37.37758*118.0119@37.376829*118.005886|8|3610112|B"
);
cCityDatas["山东省"].push(
  "临沂市|35.06265*118.33587@35.063135*118.330167|8|3609344|L"
);
cCityDatas["山东省"].push(
  "菏泽市|35.24871*115.44983@35.249002*115.443869|8|3610368|H"
);
cCityDatas["山东省"].push(
  "聊城市|36.45686*115.97994@36.456804*115.974293|8|3609856|L"
);

cCityDatas["河南省"] = new Array();
cCityDatas["河南省"].push(
  "郑州市|34.76714*113.67769@34.768225*113.671573|7|4260096|Z"
);
cCityDatas["河南省"].push(
  "开封市|34.79855*114.30335@34.799458*114.29752|8|4260352|K"
);
cCityDatas["河南省"].push(
  "洛阳市|34.67194*112.44435@34.67289*112.438058|8|4260608|L"
);
cCityDatas["河南省"].push(
  "平顶山市|33.73186*113.29903@33.733326*113.292779|8|4260864|P"
);
cCityDatas["河南省"].push(
  "焦作市|35.24328*113.23372@35.243755*113.227344|8|4261888|J"
);
cCityDatas["河南省"].push(
  "鹤壁市|35.89807*114.17749@35.898035*114.171388|8|4261376|H"
);
cCityDatas["河南省"].push(
  "新乡市|35.3056*113.86393@35.30616*113.857942|8|4261632|X"
);
cCityDatas["河南省"].push(
  "安阳市|36.09605*114.35347@36.09593*114.347423|8|4261120|A"
);
cCityDatas["河南省"].push(
  "濮阳市|35.75972*115.02106@35.759765*115.015221|8|4262144|P"
);
cCityDatas["河南省"].push(
  "许昌市|34.02552*113.82251@34.027015*113.816535|8|4263936|X"
);
cCityDatas["河南省"].push(
  "漯河市|33.58199*114.01117@33.58351*114.005275|8|4264192|L"
);
cCityDatas["河南省"].push(
  "三门峡市|34.77522*111.1923@34.776181*111.186288|8|4264448|S"
);
cCityDatas["河南省"].push(
  "商丘市|34.44623*115.66306@34.447574*115.657546|8|4264960|S"
);
cCityDatas["河南省"].push(
  "周口市|33.62657*114.63617@33.628242*114.630826|8|4265472|Z"
);
cCityDatas["河南省"].push(
  "驻马店市|32.9778*114.035@32.979615*114.029103|8|4265728|Z"
);
cCityDatas["河南省"].push(
  "信阳市|32.12872*114.06212@32.130699*114.056252|8|4265216|X"
);
cCityDatas["河南省"].push(
  "济源市|34.76714*113.67769@34.768225*113.671573|8|4296704|J"
);
cCityDatas["河南省"].push(
  "南阳市|32.99503*112.52067@32.996987*112.514783|8|4264704|N"
);

cCityDatas["湖北省"] = new Array();
cCityDatas["湖北省"].push(
  "武汉市|30.58965*114.28742@30.592094*114.282001|8|4325632|W"
);
cCityDatas["湖北省"].push(
  "黄石市|30.2183*115.0907@30.220647*115.085218|8|4325888|H"
);
cCityDatas["湖北省"].push(
  "襄樊市|32.02354*112.14802@32.025526*112.141971|8|4326912|X"
);
cCityDatas["湖北省"].push(
  "十堰市|32.63073*110.77559@32.632886*110.770256|8|4326144|S"
);
cCityDatas["湖北省"].push(
  "宜昌市|30.70277*111.29069@30.705204*111.285033|8|4326656|Y"
);
cCityDatas["湖北省"].push(
  "荆州市|30.32097*112.2809@30.323518*112.275183|8|4329472|J"
);
cCityDatas["湖北省"].push(
  "鄂州市|30.40375*114.87261@30.40642*114.867545|8|4327168|E"
);
cCityDatas["湖北省"].push(
  "孝感市|30.92749*113.91136@30.92997*113.905872|8|4327680|X"
);
cCityDatas["湖北省"].push(
  "黄冈市|30.45047*114.86834@30.453124*114.863264|8|4329728|H"
);
cCityDatas["湖北省"].push(
  "咸宁市|29.8865*114.26976@29.889043*114.264407|8|4329984|X"
);
cCityDatas["湖北省"].push(
  "荆门市|31.04024*112.19408@31.042431*112.188227|8|4327424|J"
);
cCityDatas["湖北省"].push(
  "随州市|31.72151*113.36015@31.723423*113.35397|8|4330240|S"
);
cCityDatas["湖北省"].push(
  "天门市|30.65305*113.16019@30.655375*113.154149|8|4362246|T"
);
cCityDatas["湖北省"].push(
  "仙桃市|30.37421*113.45985@30.376618*113.453823|8|4362244|X"
);
cCityDatas["湖北省"].push(
  "潜江市|30.42576*112.89449@30.428474*112.888905|8|4362245|Q"
);
cCityDatas["湖北省"].push(
  "神农架市|31.75975*110.64906@31.761995*110.644056|8|4362273|S"
);
cCityDatas["湖北省"].push(
  "恩施|30.27527*109.48157@30.277806*109.476666|8|4335616|E"
);

cCityDatas["湖南省"] = new Array();
cCityDatas["湖南省"].push(
  "长沙市|28.19602*112.99369@28.199407*112.988092|7|4391168|C"
);
cCityDatas["湖南省"].push(
  "株洲市|27.83166*113.12818@27.834789*113.122339|8|4391424|Z"
);
cCityDatas["湖南省"].push(
  "湘潭市|27.86387*112.9006@27.867364*112.895226|8|4391680|X"
);
cCityDatas["湖南省"].push(
  "衡阳市|26.89977*112.60608@26.903367*112.600857|8|4391936|H"
);
cCityDatas["湖南省"].push(
  "邵阳市|27.24231*111.47724@27.245564*111.471686|8|4392192|S"
);
cCityDatas["湖南省"].push(
  "岳阳市|29.37775*113.11599@29.380276*113.11001|8|4392448|Y"
);
cCityDatas["湖南省"].push(
  "常德市|29.03453*111.69352@29.037568*111.687932|8|4392704|C"
);
cCityDatas["湖南省"].push(
  "张家界市|29.13202*110.50037@29.134919*110.495474|8|4392960|Z"
);
cCityDatas["湖南省"].push(
  "娄底市|27.734*112.00175@27.737312*111.996224|8|4395776|L"
);
cCityDatas["湖南省"].push(
  "郴州市|25.79673*113.03127@25.799676*113.025722|8|4395008|C"
);
cCityDatas["湖南省"].push(
  "永州市|26.22927*111.61797@26.232769*111.612738|8|4395264|Y"
);
cCityDatas["湖南省"].push(
  "怀化市|27.55401*109.96634@27.55743*109.961777|8|4395520|H"
);
cCityDatas["湖南省"].push(
  "益阳市|28.58542*112.34484@28.588582*112.339159|8|4393216|Y"
);
cCityDatas["湖南省"].push(
  "湘西|28.31546*109.73358@28.318855*109.728855|8|4403456|X"
);

cCityDatas["海南省"] = new Array();
cCityDatas["海南省"].push(
  "海口市|20.04501*110.35734@20.04703*110.352922|7|4587776|H"
);
cCityDatas["海南省"].push(
  "三亚市|18.25401*109.50617@18.255686*109.502057|8|4588032|S"
);
cCityDatas["海南省"].push(
  "琼海市|19.2401*110.46144@19.241701*110.457052|8|4624386|Q"
);

cCityDatas["广东省"] = new Array();
cCityDatas["广东省"].push(
  "广州市|23.13399*113.26006@23.136667*113.254734|7|4456704|G"
);
cCityDatas["广东省"].push(
  "深圳市|22.55197*114.11819@22.554654*114.113081|8|4457216|S"
);
cCityDatas["广东省"].push(
  "珠海市|22.29112*113.57373@22.294133*113.568676|8|4457472|Z"
);
cCityDatas["广东省"].push(
  "汕头市|23.35911*116.68803@23.361763*116.683559|8|4457728|S"
);
cCityDatas["广东省"].push(
  "韶关市|24.80609*113.59365@24.809148*113.588455|8|4456960|S"
);
cCityDatas["广东省"].push(
  "河源市|23.74102*114.69069@23.743695*114.686016|8|4462080|H"
);
cCityDatas["广东省"].push(
  "梅州市|24.30948*116.11278@24.312105*116.107936|8|4461568|M"
);
cCityDatas["广东省"].push(
  "惠州市|23.11749*114.42965@23.119991*114.424693|8|4461312|H"
);
cCityDatas["广东省"].push(
  "汕尾市|22.77951*115.35582@22.78218*115.350916|8|4461824|S"
);
cCityDatas["广东省"].push(
  "东莞市|23.04873*113.75541@23.051439*113.750213|8|4462848|D"
);
cCityDatas["广东省"].push(
  "中山市|22.52654*113.38081@22.529243*113.375339|8|4464640|Z"
);
cCityDatas["广东省"].push(
  "江门市|22.60173*113.10313@22.604411*113.097668|8|4458240|J"
);
cCityDatas["广东省"].push(
  "佛山市|23.03751*113.11934@23.040048*113.113851|8|4457984|F"
);
cCityDatas["广东省"].push(
  "阳江市|21.8606*111.97772@21.863361*111.972672|8|4462336|Y"
);
cCityDatas["广东省"].push(
  "湛江市|21.1961*110.39997@21.198446*110.395431|8|4458496|Z"
);
cCityDatas["广东省"].push(
  "茂名市|21.65274*110.91773@21.655522*110.913239|8|4458752|M"
);
cCityDatas["广东省"].push(
  "肇庆市|23.05167*112.45882@23.054262*112.453536|8|4461056|Z"
);
cCityDatas["广东省"].push(
  "清远市|23.68204*113.04748@23.68453*113.042034|8|4462592|Q"
);
cCityDatas["广东省"].push(
  "潮州市|23.65934*116.61828@23.662094*116.613925|8|4477184|C"
);
cCityDatas["广东省"].push(
  "揭阳市|23.53794*116.35886@23.540363*116.354179|8|4477440|J"
);
cCityDatas["广东省"].push(
  "云浮市|22.93326*112.0375@22.935939*112.032208|8|4477696|Y"
);

cCityDatas["广西省"] = new Array();
cCityDatas["广西省"].push(
  "南宁市|22.82527*108.33199@22.828018*108.327985|7|4522240|N"
);
cCityDatas["广西省"].push(
  "柳州市|24.31427*109.40536@24.316952*109.400754|8|4522496|L"
);
cCityDatas["广西省"].push(
  "桂林市|25.2771*110.2843@25.279948*110.279731|8|4522752|G"
);
cCityDatas["广西省"].push(
  "梧州市|23.47352*111.30054@23.47609*111.295399|8|4523008|W"
);
cCityDatas["广西省"].push(
  "北海市|21.48321*109.11769@21.485594*109.113394|8|4523264|B"
);
cCityDatas["广西省"].push(
  "玉林市|22.62932*110.14988@22.632062*110.145346|8|4524288|Y"
);
cCityDatas["广西省"].push(
  "百色市|23.90521*106.63085@23.908107*106.627423|8|4526080|B"
);
cCityDatas["广西省"].push(
  "防城港市|21.61852*108.34266@21.621011*108.338696|8|4523520|F"
);
cCityDatas["广西省"].push(
  "钦州市|21.96307*108.6204@21.965998*108.61671|8|4523776|Q"
);
cCityDatas["广西省"].push(
  "贺州市|24.41308*111.54023@24.416056*111.535057|8|4526336|H"
);
cCityDatas["广西省"].push(
  "河池市|24.69723*108.05621@24.700025*108.051994|8|4526592|H"
);
cCityDatas["广西省"].push(
  "崇左市|22.41841*107.35153@22.421192*107.347408|8|4527104|C"
);
cCityDatas["广西省"].push(
  "来宾市|23.73153*109.23091@23.73417*109.226612|8|4526848|L"
);
cCityDatas["广西省"].push(
  "贵港市|23.09139*109.59715@23.094298*109.592961|8|4524032|G"
);

cCityDatas["四川省"] = new Array();
cCityDatas["四川省"].push(
  "成都市|30.66431*104.07043@30.666725*104.067918|7|5308672|C"
);
cCityDatas["四川省"].push(
  "自贡市|29.34572*104.77335@29.348567*104.770654|8|5309184|Z"
);
cCityDatas["四川省"].push(
  "攀枝花市|26.58567*101.71719@26.589243*101.715619|8|5309440|P"
);
cCityDatas["四川省"].push(
  "泸州市|28.89966*105.43945@28.902664*105.43585|8|5309696|L"
);
cCityDatas["四川省"].push(
  "德阳市|31.12774*104.39523@31.129881*104.392552|8|5309952|D"
);
cCityDatas["四川省"].push(
  "绵阳市|31.47708*104.76961@31.479278*104.766811|8|5310208|M"
);
cCityDatas["四川省"].push(
  "广元市|32.44172*105.81581@32.44406*105.812044|8|5310464|G"
);
cCityDatas["四川省"].push(
  "遂宁市|30.50645*105.57484@30.509237*105.571428|8|5310720|S"
);
cCityDatas["四川省"].push(
  "内江市|29.58249*105.0553@29.585075*105.052094|8|5312512|N"
);
cCityDatas["四川省"].push(
  "乐山市|29.55997*103.78573@29.562738*103.783535|8|5312768|L"
);
cCityDatas["四川省"].push(
  "南充市|30.79134*106.07945@30.793655*106.075449|8|5313280|N"
);
cCityDatas["四川省"].push(
  "宜宾市|28.77188*104.62066@28.775324*104.618335|8|5313792|Y"
);
cCityDatas["四川省"].push(
  "广安市|30.45832*106.62956@30.461104*106.625783|8|5314048|G"
);
cCityDatas["四川省"].push(
  "达州市|31.2146*107.49528@31.216806*107.490694|8|5314304|D"
);
cCityDatas["四川省"].push(
  "巴中市|31.85796*106.756@31.86014*106.751852|8|5314816|B"
);
cCityDatas["四川省"].push(
  "雅安市|29.98857*103.00677@29.991254*103.004938|8|5314560|Y"
);
cCityDatas["四川省"].push(
  "眉山市|30.0449*103.82987@30.047684*103.827729|8|5313536|M"
);
cCityDatas["四川省"].push(
  "资阳市|30.12419*104.65642@30.126996*104.653946|8|5316608|Z"
);
cCityDatas["四川省"].push(
  "阿坝市|31.90153*102.22008@31.903769*102.218427|8|5321216|A"
);
cCityDatas["四川省"].push(
  "甘孜市|30.05372*101.96363@30.056541*101.96211|8|5321472|G"
);
cCityDatas["四川省"].push(
  "凉山市|27.89231*102.25738@27.89575*102.255888|8|5321728|L"
);

cCityDatas["贵州省"] = new Array();
cCityDatas["贵州省"].push(
  "贵阳市|26.58719*106.7139@26.590719*106.710134|8|5374208|G"
);
cCityDatas["贵州省"].push(
  "六盘水市|26.58937*104.8434@26.59301*104.840873|9|5374464|L"
);
cCityDatas["贵州省"].push(
  "遵义市|27.69142*106.91718@27.694959*106.913382|9|5374720|Z"
);
cCityDatas["贵州省"].push(
  "铜仁市|27.7208*109.18765@27.724059*109.183063|9|5382656|T"
);
cCityDatas["贵州省"].push(
  "毕节地区|27.30777*105.28305@27.311148*105.279841|9|5383168|B"
);
cCityDatas["贵州省"].push(
  "安顺市|26.24898*105.92962@26.252543*105.926296|9|5374976|A"
);
cCityDatas["贵州省"].push(
  "黔西南市|25.0952*104.89379@25.098307*104.891338|9|5382912|Q"
);
cCityDatas["贵州省"].push(
  "黔东南市|26.58712*107.06885@26.590456*107.064623|9|5383680|Q"
);
cCityDatas["贵州省"].push(
  "黔南市|26.26107*107.51413@26.264479*107.509927|9|5383936|Q"
);

cCityDatas["云南省"] = new Array();
cCityDatas["云南省"].push(
  "昆明市|25.03736*102.71037@25.040337*102.708936|8|5439744|K"
);
cCityDatas["云南省"].push(
  "昭通市|27.33408*103.71062@27.337516*103.708541|9|5441024|Z"
);
cCityDatas["云南省"].push(
  "曲靖市|25.50314*103.79677@25.506144*103.794745|9|5440256|Q"
);
cCityDatas["云南省"].push(
  "玉溪市|24.35733*102.54419@24.360389*102.542928|9|5440512|Y"
);
cCityDatas["云南省"].push(
  "临沧市|23.88279*100.08709@23.885379*100.085839|9|5441792|L"
);
cCityDatas["云南省"].push(
  "保山市|25.11575*99.16248@25.118605*99.161561|9|5440768|B"
);
cCityDatas["云南省"].push(
  "丽江市|26.8791*100.23143@26.882644*100.2303|9|5441280|L"
);
cCityDatas["云南省"].push(
  "红河|23.36901*103.38423@23.371515*103.382194|9|5448960|H"
);
cCityDatas["云南省"].push(
  "西双版纳|22.00887*100.79784@22.011731*100.796717|9|5449728|X"
);
cCityDatas["云南省"].push(
  "楚雄|25.03612*101.54456@25.039197*101.543131|9|5448448|C"
);
cCityDatas["云南省"].push(
  "大理|25.59422*100.22252@25.59724*100.221414|9|5449984|D"
);
cCityDatas["云南省"].push(
  "德宏|24.44558*98.54238@24.448692*98.542176|9|5452032|D"
);
cCityDatas["云南省"].push(
  "怒江|25.85594*98.85266@25.859276*98.852263|9|5452544|N"
);
cCityDatas["云南省"].push(
  "迪庆|27.82186*99.70384@27.825355*99.702745|9|5452800|D"
);

cCityDatas["西藏"] = new Array();
cCityDatas["西藏"].push(
  "拉萨市|29.67571*91.12836@29.678421*91.126809|8|5505280|L"
);
cCityDatas["西藏"].push(
  "日喀则|29.27307*88.88501@29.27633*88.882978|9|5513984|R"
);

cCityDatas["陕西省"] = new Array();
cCityDatas["陕西省"].push(
  "西安市|34.30017*108.9976@34.301612*108.992755|7|6357248|X"
);
cCityDatas["陕西省"].push(
  "铜川市|35.07052*109.07037@35.071103*109.065187|8|6357504|T"
);
cCityDatas["陕西省"].push(
  "宝鸡市|34.37353*107.14178@34.374792*107.136968|8|6357760|B"
);
cCityDatas["陕西省"].push(
  "咸阳市|34.33655*108.72093@34.337979*108.716241|8|6358016|X"
);
cCityDatas["陕西省"].push(
  "延安市|36.59553*109.49127@36.595415*109.485853|8|6358528|Y"
);
cCityDatas["陕西省"].push(
  "渭南市|34.50081*109.50427@34.502103*109.499091|8|6358272|W"
);
cCityDatas["陕西省"].push(
  "商洛市|33.91029*109.87527@33.91197*109.870291|8|6361088|S"
);
cCityDatas["陕西省"].push(
  "安康市|32.68722*109.02437@32.689316*109.019542|8|6359296|A"
);
cCityDatas["陕西省"].push(
  "榆林市|38.28888*109.74866@38.288359*109.74307|8|6359040|Y"
);
cCityDatas["陕西省"].push(
  "汉中市|33.07*107.01902@33.071908*107.014534|8|6358784|H"
);

cCityDatas["甘肃省"] = new Array();
cCityDatas["甘肃省"].push(
  "兰州市|36.07967*103.77926@36.079901*103.776756|8|6422784|L"
);
cCityDatas["甘肃省"].push(
  "金昌市|38.52*102.18582@38.519554*102.183819|9|6423296|J"
);
cCityDatas["甘肃省"].push(
  "白银市|36.54591*104.1705@36.545868*104.167736|9|6423552|B"
);
cCityDatas["甘肃省"].push(
  "天水市|34.58078*105.71927@34.582107*105.71535|9|6423808|T"
);
cCityDatas["甘肃省"].push(
  "嘉峪关市|39.79764*98.26752@39.796828*98.26695|9|6423040|J"
);
cCityDatas["甘肃省"].push(
  "定西市|35.57928*104.62139@35.579831*104.618735|9|6426880|D"
);
cCityDatas["甘肃省"].push(
  "平凉市|35.54409*106.6692@35.544555*106.664978|9|6424576|P"
);
cCityDatas["甘肃省"].push(
  "庆阳市|35.72999*107.63826@35.730392*107.633532|9|6426624|Q"
);
cCityDatas["甘肃省"].push(
  "陇南市|33.77247*106.07975@33.77391*106.075548|9|6427136|L"
);
cCityDatas["甘肃省"].push(
  "武威市|37.928*102.63599@37.927719*102.634282|9|6424064|W"
);
cCityDatas["甘肃省"].push(
  "张掖市|38.93111*100.44999@38.930467*100.448285|9|6424320|Z"
);
cCityDatas["甘肃省"].push(
  "酒泉市|39.73952*98.5091@39.73874*98.508515|9|6424832|J"
);
cCityDatas["甘肃省"].push(
  "甘南市|34.9845*102.90978@34.985636*102.90806|9|6434816|G"
);
cCityDatas["甘肃省"].push(
  "临夏市|35.59653*103.20986@35.596888*103.207615|9|6433024|L"
);

cCityDatas["青海省"] = new Array();
cCityDatas["青海省"].push(
  "西宁市|36.62695*101.80335@36.627056*101.801462|8|6488320|X"
);

cCityDatas["宁夏"] = new Array();
cCityDatas["宁夏"].push(
  "银川市|38.47426*106.28956@38.473786*106.285127|9|6553856|Y"
);

cCityDatas["新疆"] = new Array();
cCityDatas["新疆"].push(
  "乌鲁木齐市|43.80553*87.61988@43.804312*87.617031|8|6619392|W"
);
cCityDatas["新疆"].push(
  "克拉玛依市|45.59896*84.87199@45.598142*84.869566|9|6619648|K"
);
cCityDatas["新疆"].push(
  "石河子市|44.30433*86.07728@44.303103*86.074447|9|6656001|S"
);
cCityDatas["新疆"].push(
  "吐鲁番|42.94195*89.1746@42.940369*89.171713|9|6627584|T"
);
cCityDatas["新疆"].push(
  "哈密地区|42.82615*93.51358@42.824627*93.511969|9|6627840|H"
);
cCityDatas["新疆"].push(
  "和田地区|37.11061*79.9352@37.11094*79.933271|9|6631936|H"
);
cCityDatas["新疆"].push(
  "阿克苏地区|41.1639*80.27809@41.162912*80.275909|9|6629632|A"
);
cCityDatas["新疆"].push(
  "喀什地区|39.46725*76.0124@39.466964*76.00938|9|6631680|K"
);
cCityDatas["新疆"].push(
  "克孜勒苏州|39.71826*76.16521@39.717836*76.162155|9|6631424|K"
);
cCityDatas["新疆"].push(
  "巴音郭楞|41.7636*86.15416@41.762106*86.151524|9|6629376|B"
);
cCityDatas["新疆"].push("昌吉|44.009*87.30239@44.007696*87.299305|9|6628096|C");
cCityDatas["新疆"].push(
  "博尔塔拉州|44.89577*82.06015@44.894765*82.056887|9|6629120|B"
);
cCityDatas["新疆"].push(
  "伊犁|43.91605*81.32064@43.914809*81.317611|9|6635520|Y"
);

cCityDatas["黑龙江省"] = new Array();
cCityDatas["黑龙江省"].push(
  "哈尔滨市|45.73957*126.66254@45.73759*126.656537|8|2294016|H"
);
cCityDatas["黑龙江省"].push(
  "齐齐哈尔市|47.34192*123.9592@47.339834*123.952588|9|2294272|Q"
);
cCityDatas["黑龙江省"].push(
  "鹤岗市|47.31386*130.28226@47.311459*130.274456|9|2294784|H"
);
cCityDatas["黑龙江省"].push(
  "双鸭山市|46.64449*131.15046@46.642237*131.142318|9|2295040|S"
);
cCityDatas["黑龙江省"].push(
  "鸡西市|45.30044*130.97651@45.298277*130.969054|9|2294528|J"
);
cCityDatas["黑龙江省"].push(
  "大庆市|46.59626*125.00504@46.594347*124.998308|9|2295296|D"
);
cCityDatas["黑龙江省"].push(
  "伊春市|47.72912*128.90458@47.726918*128.897563|9|2295552|Y"
);
cCityDatas["黑龙江省"].push(
  "牡丹江市|44.57863*129.61041@44.576693*129.60337|9|2297856|M"
);
cCityDatas["黑龙江省"].push(
  "佳木斯市|46.80981*130.36151@46.80752*130.353624|9|2295808|J"
);
cCityDatas["黑龙江省"].push(
  "七台河市|45.76782*130.99548@45.76564*130.987851|9|2296064|Q"
);
cCityDatas["黑龙江省"].push(
  "绥化市|46.63557*126.98372@46.633652*126.977361|9|2298368|S"
);
cCityDatas["黑龙江省"].push(
  "黑河市|50.24523*127.49599@50.24349*127.488535|9|2298112|H"
);
cCityDatas["黑龙江省"].push(
  "大兴安岭地区|50.41868*124.11838@50.416987*124.110749|9|2303744|D"
);

cCityDatas["其它"] = new Array();
cCityDatas["其它"].push(
  "香港|22.31881*114.18144@22.321572*114.176492|8|8454145|X"
);
cCityDatas["其它"].push("澳门|22.19907*113.55438@22.202023*113.549291|8||A");
cCityDatas["其它"].push("台湾|23.60374*121.03795@23.606173*121.034016|5||T");

export default {
  cProvinceDatas,
  cCityDatas
};
